import React from "react";
import { Switch, Route, Router } from "react-router-dom";
import history from "../../../Assets/Lib/history";
import List from "./List";
import Add from "./Add";
import Edit from "./Edit";

const Speakers = () => {
  return (
    <Router history={history}>
      <Switch>
        <Route exact path="/admin/events/speakers" component={List} />
        <Route path="/admin/events/speakers/new" component={Add} />
        <Route path="/admin/events/speakers/:id" component={Edit} />
      </Switch>
    </Router>
  );
};
export default Speakers;
